import React, { Component } from "react";
import styles from "./carsBar.module.scss";
import SideBarInner from "../../../shared/sideBarInner";
import SideBarControl from "../../sides/sideBarControl";
import LogisticTitleClosedBar from "../reports/LogisticTitleClosedBar";
import TitleBarWrapper from "../../../shared/titleBarWrapper";
import FirstTitle from "../../../shared/items/static/firstTitle";
import LogisticsList from "../../Logistics/LogisticsList/LogisticsList";
import { NavLink } from "react-router-dom";
import { withMonitoringTaskTrips } from "../../../shared/containers/containerLogisticMonitoringsTaskTrips";
import { withAuth } from "../../../shared/containers/containerAuth";

class LogisticsBar extends Component {
  render() {
    const { monitoringTaskTrip, data } = this.props;
    const isMonitorings = window.location.pathname.includes("monitorings");

    const monitoringsPermission = data.permissions.includes(54001);

    return (
      <div className={styles.sideBarsWrapper}>
        <SideBarControl TitleClosed={<LogisticTitleClosedBar />}>
          <div className={styles.reportsBar}>
            <SideBarInner>
              <TitleBarWrapper>
                <div style={{ display: "flex", position: "relative" }}>
                  <NavLink to={"/logistic/controlPoints"}>
                    <FirstTitle color={!isMonitorings ? "#408ad4" : null}>Логистика</FirstTitle>
                  </NavLink>

                  {monitoringsPermission ? (
                    <div style={{ width: "50%", right: "0px", position: "absolute" }}>
                      <NavLink
                        to={monitoringTaskTrip === null ? "/logistic/monitorings" : "/logistic/monitorings/" + monitoringTaskTrip.id}
                      >
                        <FirstTitle color={isMonitorings ? "#408ad4" : null}>Мониторинг</FirstTitle>
                      </NavLink>
                    </div>
                  ) : null}
                </div>
              </TitleBarWrapper>
            </SideBarInner>
            <LogisticsList />
          </div>
        </SideBarControl>
      </div>
    );
  }
}

export default withAuth(withMonitoringTaskTrips(React.memo(LogisticsBar)));
